import React, { useEffect, useState } from "react";
import hot from "../assets/icons/hot.svg";
import { getListing } from "../api/website/hotel/hotelApi";

const CustomListing = ({ Locations, setLocations }) => {
  const [Data, setData] = useState({ locations: [], hotels: [] });
  const [Search, setSearch] = useState("");

  const handleSearch = (e) => {
    setSearch(e.target.value);
  };

  // Locations now come straight from the location tables:
  // { cityId, cityName, isFeatured, divisionId, divisionName, countryId, countryName }
  const filteredLocations =
    Search.trim() === ""
      ? Data.locations.filter((item) => item.isFeatured)
      : Data.locations.filter((item) => {
          const q = Search.toLowerCase();
          return (
            (item.cityName || "").toLowerCase().includes(q) ||
            (item.divisionName || "").toLowerCase().includes(q) ||
            (item.countryName || "").toLowerCase().includes(q)
          );
        });

  // Hotels are only the active + featured ones.
  const filteredHotels =
    Search.trim() === ""
      ? Data.hotels
      : Data.hotels.filter((item) =>
          (item.hotelName || "").toLowerCase().includes(Search.toLowerCase()),
        );

  useEffect(() => {
    getListing(setData);
  }, []);

  const handleSelect = (item) => {
    setLocations(item);
  };
  return (
    <div className="w-full lg:w-[450px] p-4 rounded-lg bg-white drop-shadow-md">
      <div className="space-y-2">
        <div>
          <input
            className="border w-full p-1 focus:outline-none rounded-md"
            type="text"
            placeholder="Search..."
            value={Search}
            onChange={handleSearch}
          />
        </div>

        {Search.trim() === "" && (
          <div className="grid sm:grid-col-1 lg:grid-cols-2 gap-4">
            <div>
              <p className="text-xs font-bold text-[#2155ad] uppercase">
                Top Locations
              </p>
              {filteredLocations.map((item, index) => (
                <div
                  onClick={() => handleSelect(item)}
                  key={index}
                  className="flex justify-start items-center gap-x-2 py-2 cursor-pointer"
                >
                  <div>
                    <div className="flex justify-start items-center gap-x-1">
                      <p className="text-xs font-bold">{item.cityName}</p>
                      {item.isFeatured && (
                        <img width={18} src={hot} alt="featured" />
                      )}
                    </div>
                    <p className="text-[10px] text-black/50">
                      {item.divisionName}, {item.countryName}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <div>
              <p className="text-xs font-bold text-[#2155ad] uppercase">
                Top Hotels
              </p>
              {filteredHotels.map((item, index) => (
                <div
                  onClick={() => handleSelect(item)}
                  key={index}
                  className="flex justify-start items-center gap-x-2 py-2 cursor-pointer"
                >
                  <div className="w-8 h-8 overflow-hidden rounded-md border">
                    <img
                      src={item.hotelLogo}
                      alt={item.hotelName}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div>
                    <div className="flex justify-start items-center gap-x-1">
                      <p className="text-xs font-bold">{item.hotelName}</p>
                      {item.isFeatured && (
                        <img width={18} src={hot} alt="featured" />
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Search View */}
        {Search.trim() !== "" && (
          <div>
            {filteredLocations.map((item, index) => (
              <div
                onClick={() => handleSelect(item)}
                key={`loc-${index}`}
                className="flex justify-between items-center cursor-pointer py-2"
              >
                <div>
                  <p className="text-sm font-bold">{item.cityName}</p>
                  <p className="text-xs text-black/50">
                    {item.divisionName}, {item.countryName}
                  </p>
                </div>
                <p className="text-xs text-[#2155ad] font-bold">Location</p>
              </div>
            ))}

            {filteredHotels.map((item, index) => (
              <div
                onClick={() => handleSelect(item)}
                key={`hotel-${index}`}
                className="flex justify-between items-center cursor-pointer py-2"
              >
                <div className="flex justify-start items-center gap-x-2">
                  <div className="w-8 h-8 overflow-hidden rounded-md border">
                    <img
                      src={item.hotelLogo}
                      alt={item.hotelName}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div>
                    <p className="text-sm font-bold">{item.hotelName}</p>
                  </div>
                </div>
                <p className="text-xs text-[#2155ad] font-bold">Hotel</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomListing;
